package com.fantasytenis.shared.domain.contests.entity

import com.fantasytenis.shared.domain.lineup.entity.Category

/**
 * Perfect lineup slot - optimal player selection for a single category.
 */
data class PerfectLineupSlotEntity(
    val playerId: String,
    val playerName: String,
    val cost: Int,
    val points: Double
)

/**
 * Perfect lineup - the mathematically optimal lineup for a completed contest.
 * Calculated after all matches in the slate are finished.
 *
 * This shows users what the best possible lineup would have been given
 * the actual match results, respecting salary cap and unique player constraints.
 */
data class PerfectLineupEntity(
    val serve: PerfectLineupSlotEntity,
    val forehand: PerfectLineupSlotEntity,
    val backhand: PerfectLineupSlotEntity,
    val volleys: PerfectLineupSlotEntity,
    val fighting: PerfectLineupSlotEntity,
    val totalCost: Int,
    val totalPoints: Double,
    val calculatedAt: String
) {
    /**
     * Get the perfect slot for a specific category.
     */
    fun getSlotForCategory(category: Category): PerfectLineupSlotEntity {
        return when (category) {
            Category.SERVE -> serve
            Category.FOREHAND -> forehand
            Category.BACKHAND -> backhand
            Category.VOLLEYS -> volleys
            Category.FIGHTING -> fighting
        }
    }

    /**
     * Get all player IDs in the perfect lineup.
     */
    fun getAllPlayerIds(): Set<String> {
        return setOf(
            serve.playerId,
            forehand.playerId,
            backhand.playerId,
            volleys.playerId,
            fighting.playerId
        )
    }
}
